import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import msal, { setUser, getUser, loginRequest, errors, onMsalTokenError, onMsalLoginRequired } from 'lib/msal';
import * as microsoftTeams from "@microsoft/teams-js";
import getEnvironment from 'lib/env';
import { appInsights, getEnhancedLogLevel } from 'lib/appInsights';
import InteractionRequired from 'containers/Errors/InteractionRequired';
import AuthenticationPopup from 'components/Login/AuthenticationPopup';
import LoginLandingPage from 'components/Login/LandingPage';
import Authenticate from 'components/Login/Authenticate';
import GenerateToken from 'components/GenerateToken';
import LTI from 'containers/LTI';
import { Spinner } from 'UI';

var AuthenticationProvider = /*#__PURE__*/function (_Component) {
  _inherits(AuthenticationProvider, _Component);

  var _super = _createSuper(AuthenticationProvider);

  function AuthenticationProvider(props) {
    var _this;

    _classCallCheck(this, AuthenticationProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onLandingPageLogin", function (response) {
      console.log("REDIRECT SUCCESS", response);
      console.log("MSAL login status", msal.getAllAccounts());

      _this.setState({
        authenticated: true,
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAuthenticationPopupLogin", function (response) {
      if (response == null) {
        appInsights.trackTrace({
          message: "EDU017 | MSAL - authenticationPopupLogin failed (response null)"
        });
        return false;
      }

      if (_this.onAuthPopupSuccessCallback != null) {
        _this.onAuthPopupSuccessCallback();
      }

      if (msal.getAllAccounts().length > 0) {
        _this.setState({
          authenticated: true,
          authPopup: false
        });
      } else {
        appInsights.trackTrace({
          message: 'EDU017b | MSAL - authenticationPopupLogin got 0 account length'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setAuthenticationState", function (username) {
      if (microsoftTeams.app.isInitialized()) {
        microsoftTeams.authentication.getAuthToken().then(function (token) {
          microsoftTeams.app.getContext().then(function (context) {
            console.log("User is set in localstorage", context);
            setUser(context.user.userPrincipalName); // user's email or User Principal Name

            _this.setState({
              authenticated: true,
              loading: false
            });
          });
        })["catch"](function (error) {
          console.error("Error getting token: ", error);

          _this.setState({
            authenticated: false,
            loading: false
          });
        });
      } else {
        var account = msal.getAllAccounts().find(function (acc) {
          return acc.username === username;
        });
        console.log(msal.getAllAccounts());

        if (account) {
          setUser(account.username);

          _this.setState({
            authenticated: true,
            loading: false
          });
        } else {
          _this.setState({
            authenticated: false,
            loading: false
          });
        }
      }
    });

    _this.state = {
      authenticated: false,
      loading: _this.inIframe(),
      interactionRequired: false,
      error: null,
      authPopup: false
    };
    _this.onAuthPopupSuccessCallback = null;
    return _this;
  }

  _createClass(AuthenticationProvider, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      onMsalTokenError(function (error) {
        if (error.errorCode === 'invalid_grant' || error.errorCode === 'interaction_required') {
          _this2.setState({
            loading: false,
            interactionRequired: true,
            error: error
          });
        }

        if (error === 'login_required') {
          _this2.setState({
            loading: false,
            authenticated: false
          });
        }
      });
      onMsalLoginRequired(function () {
        return new Promise(function (resolve) {
          _this2.setState({
            authPopup: true
          });

          _this2.onAuthPopupSuccessCallback = function () {
            return resolve(1);
          };

          if (getEnhancedLogLevel() > 0) {
            appInsights.trackTrace({
              message: 'EDU015a | Running login auth flow in AuthenticationProvider'
            }, {
              logLevel: getEnhancedLogLevel()
            });
          }
        });
      });

      if (microsoftTeams.app.isInitialized()) {
        microsoftTeams.app.getContext().then(function (context) {
          _this2.setAuthenticationState(context.user.userPrincipalName);
        });
      } else {
        var _getUser;

        var activeLoggedInUser = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.username;
        this.setAuthenticationState(activeLoggedInUser);
      } // If app boots and user has haldor-teams-auth-progress in store, delete it


      if (localStorage.getItem('haldor-teams-auth-progress') != null) {
        localStorage.removeItem('haldor-teams-auth-progress');
      } // If not in callback mode and localStorage interaction status is in_progress, clear that value


      var interaction_status = localStorage.getItem("msal.".concat(getEnvironment().clientId, ".interaction.status"));

      if (interaction_status != null && interaction_status == 'interaction_in_progress') {
        localStorage.setItem("msal.".concat(getEnvironment().clientId, ".interaction.status"), '');
      }
    }
  }, {
    key: "render",
    value: function render() {
      console.log(window.location.pathname);
      console.log('AuthenticatedProvider is authenticated', this.state.authenticated, this.state.loading);

      if (window.location.pathname == '/lti') {
        return /*#__PURE__*/React.createElement(LTI, null);
      }

      if (window.location.pathname == '/authenticate') {
        return /*#__PURE__*/React.createElement(Authenticate, null);
      }

      if (window.location.pathname == '/GenerateToken') {
        return /*#__PURE__*/React.createElement(GenerateToken, null);
      }

      if (this.state.interactionRequired) {
        return /*#__PURE__*/React.createElement(InteractionRequired, {
          error: this.state.error
        });
      }

      if (this.state.authenticated && !this.state.loading || window.location.pathname == "/authenticate/callback") {
        return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.authPopup ? /*#__PURE__*/React.createElement(AuthenticationPopup, {
          onLogin: this.onAuthenticationPopupLogin
        }) : null, this.props.children);
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement(LoginLandingPage, {
        onLoginSuccess: this.onLandingPageLogin
      });
    }
  }]);

  return AuthenticationProvider;
}(Component);

export default AuthenticationProvider;